module.exports = __webpack_public_path__ + "static/media/Group 25895.30aa1dae.svg";